import { useEffect, useState } from 'react';

import { autoCreditApi } from '@/integrations/app.api/auto-credit.api';
import { keysToCamelCase } from '@/services';
import { useAppSelector } from '@/store';
import { type KeysToCamelCase } from '@/types/app';
import { type TOnlineRequestStatus } from '@/types/request';

interface IProps {
  shouldRequest: boolean;
}

const useOnlineAutoCreditHistory = ({ shouldRequest }: IProps) => {
  const { orderApp } = useAppSelector((state) => state.newOrder);

  const [data, setData] = useState<KeysToCamelCase<TOnlineRequestStatus>[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const requestId = orderApp?.onlineClientRequest?.uuid;

    if (!shouldRequest || !orderApp?.isOnlineRequest || !requestId) return;

    (async () => {
      setIsLoading(true);
      try {
        const response = await autoCreditApi.getOnlineRequestHistory(requestId);
        setData(keysToCamelCase(response));
      } finally {
        setIsLoading(false);
      }
    })();
  }, [shouldRequest, orderApp]);

  return {
    onlineAutoCreditData: data,
    onlineAutoCreditLoading: isLoading
  };
};

export default useOnlineAutoCreditHistory;
